var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Oops! Something is wrong.")]),_c('a',{staticClass:"button cursor-pointer",on:{"click":function($event){return _vm.goBack()}}},[_c('span',{staticClass:"mdi mdi-24px mdi-home"}),_vm._v(" Go back in initial page, is better.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }